module.exports = __webpack_public_path__ + "static/valueCapture-9a072c65e54b975e4e6a4b78bd50b312.svg";